<cs-content>
  <cs-card-list narrow>
    <cs-info-card type="translucent" [centered]="true" [dismissible]="false">
      <img class="logo" src="assets/imgs/logo.svg" />
    </cs-info-card>
    @if (state === PageState.NoSession) {
    <cs-info-card type="error" [dismissible]="false" [message]="LL.cliAuth.errors.noSession()"></cs-info-card>
    }

    @if (state === PageState.NotSignedIn) {
    <cs-info-card type="error" [dismissible]="false" [message]="LL.cliAuth.errors.notSignedIn()"></cs-info-card>
    }

    @if (state === PageState.Error) {
    <cs-info-card type="error" [dismissible]="false" [message]="errorMessage"></cs-info-card>
    }

    @if (state === PageState.Ready || state === PageState.Approving || state === PageState.Approved || state === PageState.Denied) {
    <cs-card>
      @if (state === PageState.Ready) {
      <div class="login-header">
        <div class="title">{{ LL.cliAuth.allowAccess() }}</div>
      </div>
      <cs-note big light>
        {{ LL.cliAuth.description() }}
        <ul>
          <li>{{ LL.cliAuth.permissions.downloadData() }}</li>
          <li>{{ LL.cliAuth.permissions.actOnBehalf() }}</li>
        </ul>
      </cs-note>
      <cs-note>{{ LL.cliAuth.confirmAccess({ email: userEmail }) }}</cs-note>
      <cs-item-list>
        <cs-item>
          <cs-button medium item-left fit-width secondary (click)="onDenyClick()"
            [label]="LL.cliAuth.buttons.deny()"></cs-button>
          <cs-button medium item-right fit-width (click)="onAuthorizeClick($event)"
            [label]="LL.cliAuth.buttons.allow()"></cs-button>
        </cs-item>
      </cs-item-list>
      }

      @if (state === PageState.Approving) {
      <div class="login-header">
        <div class="title">{{ LL.cliAuth.authorizing() }}</div>
      </div>
      <cs-spinner></cs-spinner>
      }

      @if (state === PageState.Approved) {
      <div class="login-header success">
        <div class="title">{{ LL.cliAuth.approved() }}</div>
      </div>
      <cs-note>{{ LL.cliAuth.approvedDetail() }}</cs-note>
      }

      @if (state === PageState.Denied) {
      <div class="login-header">
        <div class="title">{{ LL.cliAuth.denied() }}</div>
      </div>
      <cs-note>{{ LL.cliAuth.deniedDetail() }}</cs-note>
      }
    </cs-card>
    }
  </cs-card-list>
</cs-content>